import React from 'react'
import NavBar from '../components/Home/NavBar'
import LandingCarousel from '../components/Carousel/Carousel';
import img1 from '../assets/carouselImages/carousel1.png'
import img2 from '../assets/carouselImages/carousel2.png'
import img3 from '../assets/carouselImages/carousel3.png'
import img4 from '../assets/carouselImages/carousel4.png'
import CarouselTextContent from '../components/Carousel/CarouselTextContent';
import TopHomeInfo from '../components/Home/TopHomeInfo';
import NextSteps from '../components/Home/NextSteps';

const images = [
  img1,
  img2,
  img3,
  img4
];


const Home = (): JSX.Element => {
  return (
   <div className='w-screen h-screen'>
      <div className='top-0 sticky'>
        <NavBar/>
      </div>

      <TopHomeInfo />

      <div className='bg-background_home text-white pl-12 pt-12'>
        <h1 className='text-lg font-bold'>PASOS PARA EMPEZAR EL TRÁMITE:</h1>
      </div>
      
      <div className='h-auto flex sm:flex-row flex-col gap-12 sm:p-12 px-12 py-4 bg-background_home'>
        <CarouselTextContent />
        <LandingCarousel images={images} />      
      </div>
 
     
      <div>
      <NextSteps/>
      </div>   

   </div>
  )
}

export default Home